import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import DateCell from '../../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../../elements/Table/Cells/StatusCell'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import FileCell from '../../../../elements/Table/Cells/FileCell'
import PropTypes from 'prop-types'
import { formatQueryParams } from '../../../../modules/Utils'

const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    width: 300,
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/operations/engineering/dwg/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  { Header: 'Rev', accessor: 'revision', width: 50 },
  {
    Header: 'Client QC No',
    accessor: 'client.dwgNo',
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/rfq/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
    hideable: true,
    hideDefault: true,
  },
  { Header: 'Client Rev', accessor: 'client.revision', hideable: true, hideDefault: true },
  {
    Header: 'Enquiry',
    accessor: 'enquiry.code',
    hideable: true,
    width: 120,
  },
  {
    Header: 'Sales Order',
    accessor: 'order.code',
    hideable: true,
    hideDefault: false,
    width: 120,
  },
  {
    Header: 'Due Date',
    accessor: 'date.due',
    Cell: DateCell,
    hideable: true,
    hideDefault: true,
  },
  { Header: 'Title', accessor: 'title', style: { textAlign: 'left' } },
  { Header: 'Status', accessor: 'status', width: 200, Cell: StatusCell },
  {
    Header: 'Issued',
    accessor: 'issuance.issued',
    width: 200,
    Cell: ({ value }) => value === true && <span>Issued</span>,
    hideable: true,
    hideDefault: false,
  },
  {
    Header: 'File',
    accessor: 'file',
    width: 100,
    Cell: FileCell,
    hideable: true,
    hideDefault: false,
  },
]

function DWGList(props) {
  const { list, fetch, fetching, company, onChangeCompany, enquiryID, hideCompany } = props
  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() =>
        hideCompany !== true && (
          <OrganisationsSelect
            value={company}
            onChange={onChangeCompany}
            placeholder={'Filter by a company'}
            size={'small'}
            style={{ width: '450px', paddingRight: 20, float: 'right' }}
          />
        )
      }
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={() => {
            props.history.push({
              pathname: `/operations/engineering/dwg/new/`,
              search: formatQueryParams('enquiryID', enquiryID, true),
            })
          }}>
          New
        </Button>
      )}
      columns={columns}
    />
  )
}

DWGList.propTypes = {
  list: PropTypes.any,
  fetch: PropTypes.any,
  fetching: PropTypes.any,
  company: PropTypes.any,
  onChangeCompany: PropTypes.any,
  hideCompany: PropTypes.bool,
}
DWGList.defaultProps = {}

export default withRouter(DWGList)
